import script from "./categorizedProductDisplayTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./categorizedProductDisplayTwo.vue?vue&type=script&setup=true&lang=js"

import "./categorizedProductDisplayTwo.vue?vue&type=style&index=0&id=d87b27ac&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d87b27ac"]])

export default __exports__